interface TrustStripProps {
  items: string[];
  className?: string;
}

export function TrustStrip({ items, className = '' }: TrustStripProps) {
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      {items.map((item) => (
        <span
          key={item}
          className="inline-flex items-center gap-1.5 rounded-pill border border-border-soft bg-surface/60 px-3 py-1.5 text-xs text-ink-muted font-ui backdrop-blur-sm"
        >
          <svg className="w-3 h-3 text-success" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
          {item}
        </span>
      ))}
    </div>
  );
}
